import { AbstractBomValue } from "./abstractBomValue";

export class StoredBomValue extends AbstractBomValue {
}